<template>
    <fieldset>
        <ul class="m-list-form">
            <li v-for="r in radioContent" class="m-list-form-item" :key="`${name}_${r.value}`">
                <form-radio :name="name" :value="r.value" :label="r.label" :is-default-checked="r.value === defaultChecked" @input="updateValue" />
            </li>
        </ul>
    </fieldset>
</template>

<script>
    import FormRadio from "../atoms/FormRadio.vue";
    export default {
        name: "ListFormRadio",
        components: { FormRadio },
        props: {
            /**
             * ラジオボタンリストの配列
             */
            radioContent: {
                type: Array,
                required: true,
            },
            /**
             * name属性
             */
            name: {
                type: String,
                required: true
            },
            /**
             * 初期値
             */
            defaultChecked: {
                type: String,
                required: false,
                default: ""
            }
        },
        emits: ['update:modelValue'],
        methods: {
            updateValue(value) {
                this.$emit("update:modelValue", value);
            }
        }
    }
</script>
